import types from '@/constants/types';

const actions = {
  [types.actions.SAVE_USER]: ({ commit }, user) => {
    commit(types.mutations.SAVE_USER, user);
  },
  [types.actions.SAVE_TOKEN]: ({ commit }, user) => {
    commit(types.mutations.SAVE_TOKEN, user);
  },
  [types.actions.REMOVE_ALL]: ({ commit }) => {
    commit(types.mutations.REMOVE_ALL);
  },
};

export default {
  ...actions,
};
